const signUpFormFields = {
    signUp: {
      username: {
        label: 'Nombre de usuario',
        placeholder: 'Ingresa tu nombre de usuario',
        required: true,
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Ingresa tu contraseña',
        required: true,
      },
      confirm_password: {
        label: 'Confirmar contraseña',
        placeholder: 'Confirma tu contraseña',
        required: true,
      },
      given_name: {
        label: 'Nombre',
        placeholder: 'Ingresa tu nombre',
        required: true,
      },
      family_name: {
        label: 'Apellido',
        placeholder: 'Ingresa tu apellido',
        required: true,
      },
      birthdate: {
        label: 'Fecha de nacimiento',
        placeholder: 'Ingresa tu fecha de nacimiento (YYYY-MM-DD)',
        type: 'date',
        required: true,
      },
    },
  };
  
  export default signUpFormFields;